export const DOCUMENT_TAB_CATEGORIES = [
    "manual",
    "boms",
    "mechanical-drawings",
    "electrical-drawings",
    "compliance",
    "food-compliance",
    "translations",
    "others",
];

export const KNOWN_DOCUMENT_CATEGORIES = [
    "manual",
    "boms",
    "mechanical-drawings",
    "electrical-drawings",
    "compliance",
    "food-compliance",
    "translations",
];

export const normalizeDocumentCategoryKey = (value = "") => {
    const normalized = String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

    const aliases = {
        certificate: "compliance",
        certificates: "compliance",
        "food-conformity": "food-compliance",
        uncategorized: "others",
        rspl: "others",
    };

    return aliases[normalized] || normalized;
};

export const getDocumentCategoryLabel = (t, categoryKey) => {
    const labels = {
        manual: t("LABELS.MANUALS"),
        boms: t("LABELS.BOMS"),
        "mechanical-drawings": t("LABELS.MECHANICAL_DRAWINGS"),
        "electrical-drawings": t("LABELS.ELECTRICAL_DRAWINGS"),
        compliance: t("LABELS.COMPLIANCE"),
        "food-compliance": t("LABELS.FOOD_COMPLIANCE"),
        translations: t("LABELS.TRANSLATIONS"),
        others: t("LABELS.OTHERS"),
    };

    return labels[categoryKey] || categoryKey;
};
